import PropTypes from 'prop-types';
import React, { useRef, useState, memo } from 'react';
import './Crow.scss';
import { Player } from '@lottiefiles/react-lottie-player';
import imageCrowV2Jump from '../../assets/images/crow/crow_v2_jump.json';
import imageCrowV2Left from '../../assets/images/crow/crow_v2_left.json';
import imageCrowV2Right from '../../assets/images/crow/crow_v2_right.json';

const imagesLeft = [
	imageCrowV2Left,
];

const imagesRight = [
	imageCrowV2Right,
];

export const Crow = memo(props => {
	const { className } = props;
	const [src, setSrc] = useState(imagesLeft[0]);
	const [hasBeenHovered, setHasBeenHovered] = useState(false);
	const ref = useRef();

	const playNext = () => {
		const index = Math.floor(Math.random() * 0);
		if (hasBeenHovered)
			setSrc(imagesRight[index]);
		else
			setSrc(imagesLeft[index]);
		ref.current.play();
	}
	const handleMouseMove = () => {
		if (!hasBeenHovered) {
			setHasBeenHovered(true);
			
			ref.current.pause();
			setSrc(imageCrowV2Jump);
			ref.current.play();
		}
	};

	return (
		<div className={className} onMouseOver={handleMouseMove}>
			<Player
				autoplay
				src={src}
				ref={ref}
				onEvent={(state) => state === 'pause' && playNext()}
			/>
		</div>
	);
});

Crow.propsTypes = {
	className: PropTypes.string
};
